//#region src/badge_category_warning_type.ts
var BadgeCategoryWarningType = /* @__PURE__ */ function(BadgeCategoryWarningType) {
	BadgeCategoryWarningType["HighSugar"] = "high-sugar";
	BadgeCategoryWarningType["HighSodium"] = "high-sodium";
	return BadgeCategoryWarningType;
}(BadgeCategoryWarningType || {});
//#endregion
export { BadgeCategoryWarningType };

//# sourceMappingURL=badge_category_warning_type.js.map